import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const type = new AxiosInterceptor();

export default {
  get(qstr = {}, arr) {
    qstr = fx.urlQueryString(qstr, false);
    let url = qstr + "&";
    if (arr) {
      Object.keys(arr).map((va) => {
        url = url + fx.parameterizeArray(va, arr[va]);
      });
    }
    return type.get("/type?" + url);
  },
  delete(id) {
    return type.delete("/type/" + id);
  },
  create(inputs) {
    return type.post("/type", {
      name: inputs.name
    });
  }
};
